export default __webpack_public_path__ + "static/media/icn_dark.8f6309b8.svg";